export default {"src":"/_next/static/media/Irregular Periods.40272625.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};